import { useContext, useLayoutEffect } from 'react';
import { FilterContext } from './FilterProvider';

export function useFilterControl(filter) {
  const { registerFilter, setFilterValue, filters } = useContext(FilterContext);

  useLayoutEffect(() => {
    registerFilter(filter);
  }, [registerFilter, filter]);

  return [filters[filter.name], value => setFilterValue(filter.name, value)];
}
